
      import Right from './right.vue'
      import type { App, Plugin } from 'vue'

      export const RightPlugin: Plugin = {
        install(app: App) {
          app.component('Right', Right)
        },
      }
      export { Right }
      